export function extendVCard(ICO){
ICO.genQR = function(i){
    var id = document.getElementById("ICO-vcard-"+i);

    ICO.qrcode = new QRCode(id, {
            //changing --ICO-QR-dimensions in root varibles in ICO.CSS will set both the div dimensions and the dimensions here.
            width: parseInt(getComputedStyle(id).getPropertyValue('--ICO-QR-dimensions')),
            height: parseInt(getComputedStyle(id).getPropertyValue('--ICO-QR-dimensions')),
            colorDark: ICO.params.QRColorDk,
            colorLight: ICO.params.QRColorLt,
            correctLevel : QRCode.CorrectLevel.M,
        });

        ICO.qRCodeImg = document.querySelector('#ICO-vcard-'+ i + ' img');
        ICO.qRCodeImg.setAttribute('id', 'ICO-upload-' + i);
        ICO.qRCodeImg.setAttribute('ref', i);

        ICO.makeCode("ICO-QR-Text");     

        var callback = function(mutationsList, observer) {
            for(var mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
                    ICO.vars.imageCrops[ICO.qRCodeImg.getAttribute('ref')] = ICO.qRCodeImg.src;
                }
            }
        };
        
        // Create an instance of MutationObserver with the callback function
        var observer = new MutationObserver(callback);
        
        // Set the configuration object to observe attribute changes
        var config = { attributes: true, childList: false, subtree: false };
        
        // Start observing the target node for configured mutations
        observer.observe(ICO.qRCodeImg, config);
};

ICO.makeCode = function(id){

    var elText = document.getElementById(id);
    if (ICO.settings.debug===true){
        console.log("QR contents: \n"+elText.value);
    }

    if (!elText.value) {
        elText.focus();
        return;
    }
    ICO.qrcode.makeCode(elText.value);
}

//LAyout function
ICO.qrGen = function(text, i){
      
    var div = document.getElementById('ICO-create');

    var textDiv = document.createElement('div');
    textDiv.setAttribute('class','ICO_text_input_div');
    textDiv.setAttribute('id','ICO-QR-input-' + i);
    div.appendChild(textDiv);

 
    var inputTitle = document.createElement('h3');
    inputTitle.setAttribute('class','ICO_input_title');
    inputTitle.setAttribute('id','ICO-input-title' + i);
    if(ICO.settings.qrcard.vcard === true){
    inputTitle.appendChild(document.createTextNode(ICO.vars.vCardHeading + ':'));
    } else inputTitle.appendChild(document.createTextNode(ICO.vars.qRCodeHeading + ':'));
    textDiv.appendChild(inputTitle);

    //Text input is hiddent when the vcard param is true. Its contents ALWAYS determines the QR code content, however. 
    var textInput = document.createElement('textarea');
        textInput.setAttribute('type','text');
        textInput.setAttribute('name',text.token);
        textInput.setAttribute('id', "ICO-QR-Text");
        textInput.setAttribute('class','ICO_text_input');
        textInput.setAttribute('placeholder', text.label);
    if (text.required == true){
       textInput.required = true;
    }      
    textDiv.appendChild(textInput);
    var placeholder = document.createTextNode(ICO.vars.placeholder);
    textInput.appendChild(placeholder);

    //If vcard is true, generate the fields for the Vcard encoding
    if (ICO.settings.qrcard.vcard == true){
        ICO.vCardFields(i, textDiv);
    } else {
        ICO.makeVAlert(textDiv);
    }

    ICO.basicButton(textDiv, ICO.vars.vCardGen, 'ICO-QR-gen', 'ICO.makeQrCard()');

    //Div for qrcode.js
    var qrDIV = document.createElement('div');
    qrDIV.setAttribute('name',text.token);
    qrDIV.setAttribute('id', "ICO-vcard-" + i);
    qrDIV.setAttribute('class','ICO-center ICO-QR');
    qrDIV.setAttribute('placeholder', text.label);
    
    textDiv.appendChild(qrDIV);
    if (ICO.settings.qrcard.vcard == true && ICO.settings.debug != true){
        textInput.style.display="none";
    }

    if(ICO.settings.qrcard.NFC){
        ICO.bytesCounter = document.createElement('p');
        ICO.bytesCounter.setAttribute('class','ICO-center ICO-small');
        ICO.bytesCounter.setAttribute('id','ICO-vCard-bytes');    
        ICO.bytesCounter.innerHTML = ICO.byteCount(ICO.vars.placeholder) + '/'+ICO.vars.maxBytes +' bytes (NFC)';
        textDiv.appendChild(ICO.bytesCounter);
    }
   
    
    var inputMessage = document.createElement('p');
    inputMessage.setAttribute('class','ICO-center ICO-veri');
    inputMessage.setAttribute('id','ICO-input-text' + i);
    inputMessage.appendChild(document.createTextNode(ICO.vars.qRVerifyText));
    textDiv.appendChild(inputMessage);

    ICO.genQR(i);
    ICO.vars.imageCrops[ICO.qRCodeImg.getAttribute('ref')] = ICO.qRCodeImg.src;
}

    ICO.vCardFields = function(
                        i, //instance (athough muliple instances not yet supported)
                        textDiv //div for placing fields
                        ){
        //contact info fields    
        var contactDiv = document.createElement('div');
        contactDiv.setAttribute('class','ICO_text_input_div ICO-toggled');
        contactDiv.setAttribute('id','ICO-QR-contact-input-' + i);
        textDiv.appendChild(contactDiv);
        ICO.addToggleBar(contactDiv, ICO.vars.vContactToggle, true);

        ICO.vFields=['v-card-N','v-card-FN', 'v-card-EMAIL'];
        ICO.addTextField(contactDiv, ICO.vars.vFullName, 'h4', "v-card-N", ICO.vars.vFullNameEg, true, true);
        ICO.addTextField(contactDiv, ICO.vars.vDispName, 'h4', "v-card-FN", ICO.vars.vDispNameEg, true, true);   
        ICO.addTextField(contactDiv, ICO.vars.vEMail, 'h4', "v-card-EMAIL", ICO.vars.vEMailEg, true, true); 

        var phDiv = document.createElement('div');
            phDiv.setAttribute('id','vCard-phones-div');
            contactDiv.appendChild(phDiv);        
        ICO.vTELs = 0;
        ICO.vTelDivs = [];
        ICO.addVPhone(phDiv, ICO.vars.vTelTypes);
            ICO.addVPhoneTxt.style.marginTop = '-25px';
            ICO.addVPhoneTxt.style.cursor = 'pointer';
            ICO.addVPhoneTxt.style.textDecorationLine = 'underline';
            ICO.addVPhoneTxt.addEventListener('click', function(){
                ICO.addVPhone(phDiv, ICO.vars.vTelTypes);
            });



        var addDiv = document.createElement('div');
            addDiv.setAttribute('id','vCard-addresses-div');
            contactDiv.appendChild(addDiv);
        ICO.vADRs = 0;
        ICO.vAdrDivs = [];
        ICO.addVAdr(addDiv, ICO.vars.vAddTypes);
            ICO.addVAdrTxt.style.marginTop = '-25px';
            ICO.addVAdrTxt.style.cursor = 'pointer';
            ICO.addVAdrTxt.style.textDecorationLine = 'underline';
            ICO.addVAdrTxt.addEventListener('click', function(){
                ICO.addVAdr(addDiv, ICO.vars.vAddTypes);
            });

        //add business info fields    
        var bussDiv = document.createElement('div');
        bussDiv.setAttribute('class','ICO_text_input_div ICO-toggled');
        bussDiv.setAttribute('id','ICO-QR-business-input-' + i);
        textDiv.appendChild(bussDiv);
        ICO.addToggleBar(bussDiv, ICO.vars.vBusinessToggle, false);

        ICO.addTextField(bussDiv, ICO.vars.vOrg, 'h4', "v-card-ORG", ICO.vars.vOrgEg, false, true);
        ICO.addTextField(bussDiv, ICO.vars.vURL, 'h4', "v-card-URL", ICO.vars.vURLEg, false, true);
        ICO.addTextField(bussDiv, ICO.vars.vTitle, 'h4', "v-card-TITLE", ICO.vars.vTitleEg, false, true);
        ICO.addTextField(bussDiv, ICO.vars.vRole, 'h4', "v-card-ROLE", ICO.vars.vRoleEg, false, true);

        //add additional fields
        var infoDiv = document.createElement('div');
        infoDiv.setAttribute('class','ICO_text_input_div ICO-toggled');
        infoDiv.setAttribute('id','ICO-QR-business-input-' + i);
        textDiv.appendChild(infoDiv);
        ICO.addToggleBar(infoDiv, ICO.vars.vInfoToggle, false);
        
        var vNote = document.createElement('h4');
        vNote.innerHTML = ICO.vars.vNote;
        vNote.setAttribute('class', 'ICO_input_title');
        infoDiv.appendChild(vNote);


        var addInfo = document.createElement('textarea');
        addInfo.setAttribute('type','text');
        addInfo.setAttribute('name', 'vCard-note-' + i);
        addInfo.setAttribute('id', 'vCard-NOTE');
        addInfo.setAttribute('class','ICO_text_input');
        infoDiv.appendChild(addInfo);

        ICO.makeVAlert(textDiv);
            
        //This assures the labels to the left og the inputs are all the same width
        ICO.adjustTitleBoxWidths();
    }

ICO.makeVAlert = function(textDiv){
    var alert = document.createElement('div');
    alert.setAttribute('class','ICO-alerts');
    alert.setAttribute('id','ICO-vCard-alert');
    textDiv.appendChild(alert);
},

ICO.addVPhone = function(
                    div, //div where it's added
                    type) //array of types for checkboxes from ICO_variables.js
                    
{
    var phoneDiv = document.createElement('div');
    let dId = 'vCard-phone-div'+ ++ICO.vTELs;
    phoneDiv.setAttribute('id', dId);
    div.appendChild(phoneDiv);
    ICO.vTelDivs.push(dId);


    ICO.addTextField(phoneDiv, ICO.vars.vTel + " " + ICO.vTELs, 'h4', "v-card-TEL" +  ICO.vTELs, ICO.vars.vTelEg, false, true);

    ICO.vFieldMultiple(phoneDiv, type,"v-card-TEL" +  ICO.vTELs);

    if (ICO.vTELs === 1){
        ICO.addVPhoneTxt = ICO.addendumText(div,ICO.vars.vTelAdd,'right');
    }else if(1 < ICO.vTELs && ICO.vTELs < type.length ){
        div.appendChild(ICO.addVPhoneTxt);
    }else {
        ICO.addVPhoneTxt.style.display='none';
    }
    ICO.adjustTitleBoxWidths();
}

ICO.addVAdr = function(
                div, //div where it's added
                type) //array of types for checkboxes from ICO_variables.js
    
{
    var adrDiv = document.createElement('div');
    let dId = 'vCard-address-div'+ ++ICO.vADRs;
    adrDiv.setAttribute('id', dId);
    div.appendChild(adrDiv);
    ICO.vAdrDivs.push(dId);
/*  //Old way of generating on a single line
    ICO.addTextField(adrDiv, ICO.vars.vAdd + " " + ICO.vADRs, 'h4', "v-card-ADR-l1-" +  ICO.vADRs, 'address line 1', false, true);
    ICO.addTextField(adrDiv, "", 'div', "v-card-ADR-l2-" +  ICO.vADRs, 'address line 2', false, true);
*/   
    //create flex div for title and fields
    var flexDiv =ICO.flexDiv('v-card-ADR'+ICO.vADRs, true);
        adrDiv.appendChild(flexDiv);
    //insert Heading in the flex div
    
    var headDiv = ICO.RightFlexText('h4', 'v-card-ADR'+ICO.vADRs, ICO.vars.vAdd+' '+ICO.vADRs);
    
        flexDiv.appendChild(headDiv);

    var fieldsDiv = document.createElement('div');
        fieldsDiv.style.width='100%';
        flexDiv.appendChild(fieldsDiv);

    fieldsDiv.appendChild(ICO.basicInput("v-card-ADR-l1-" +  ICO.vADRs, ICO.vars.adLn1, false));
    fieldsDiv.appendChild(ICO.basicInput("v-card-ADR-l2-" +  ICO.vADRs, ICO.vars.adLn2, false));

    var cityStateZip = ICO.flexDiv('v-add-CSZ-'+ ICO.vADRs, true);
    cityStateZip.style.flexWrap = "wrap";
        fieldsDiv.appendChild(cityStateZip);
    var city = ICO.basicInput('v-ADR-city-'+ ICO.vADRs, ICO.vars.adCity, false);
        city.style.minWidth = "150px";
        city.style.flexGrow = "1";
        city.style.flex = "1";
        cityStateZip.appendChild(city)
    var state = ICO.basicInput('v-ADR-state-'+ ICO.vADRs, ICO.vars.adState, false);
        state.style.marginLeft = '10px';
        state.style.maxWidth = '100px';
        state.style.minWidth = "75px"
        state.style.flexGrow = '1';
        state.style.flex = "1";
        cityStateZip.appendChild(state)
    var zip = ICO.basicInput('v-ADR-zip-'+ ICO.vADRs, ICO.vars.adZIP, false);
        zip.style.marginLeft = '10px';
        zip.style.maxWidth = "100px";
        zip.style.minWidth = "70px";
        zip.style.flex = "1";
        zip.style.flexGrow = "1";
        cityStateZip.appendChild(zip)
        
    fieldsDiv.appendChild(ICO.basicInput("v-card-ADR-country-" +  ICO.vADRs, ICO.vars.adCountry, false));



    ICO.vFieldMultiple(adrDiv, type,"v-card-ADR" +  ICO.vADRs);

    if (ICO.vADRs === 1){
    ICO.addVAdrTxt = ICO.addendumText(div,ICO.vars.vAddAdd,'right');
    }else if(1 < ICO.vADRs && ICO.vADRs < type.length ){
    div.appendChild(ICO.addVAdrTxt);
    }else {
    ICO.addVAdrTxt.style.display='none';
    }
    ICO.adjustTitleBoxWidths();
}

ICO.vFieldMultiple = function(
                        id, //DIV where is generated
                        type, //array of types for checkboxes from ICO_variables.js
                        fieldId,) //corresponding text field ID
{
    // Create a container for checkboxes
    var checkboxesContainer = document.createElement('div');
    checkboxesContainer.setAttribute('class', 'ICO-checkboxes-container ICO_input_left_title');

    // Iterate through each type and create a checkbox
    type.forEach(function(item) {
        // Create a div for each checkbox and label
        var checkboxDiv = document.createElement('div');
        checkboxDiv.setAttribute('class', 'ICO-checkboxes-div');

        // Create the checkbox
        var checkbox = document.createElement('input');
            checkbox.setAttribute('type', 'checkbox');
            checkbox.setAttribute('id', fieldId + '-' + item);
            checkbox.setAttribute('name', item);
            checkbox.setAttribute('class', 'ICO-larger-checkbox');

        // Create the label
        var label = document.createElement('label');
            label.setAttribute('class', 'ICO-check-label');
            label.setAttribute('for', fieldId + '-' + item);
            label.textContent = item.charAt(0).toUpperCase() + item.slice(1); // Capitalize the first letter

        // Append the checkbox and label to the div
        checkboxDiv.appendChild(checkbox);
        checkboxDiv.appendChild(label);

        // Append the div to the checkboxes container
        checkboxesContainer.appendChild(checkboxDiv);
    });

    // Append the checkboxes container to the target div
    id.appendChild(checkboxesContainer);

}

ICO.makeQrCard = function(){
    ICO.clearAlerts();
    if (ICO.settings.qrcard.vcard === true){
        ICO.makeVCard()        
    } else ICO.restQR();
}

ICO.appVString = function(st, el, last){
    if(el===undefined){
        el='';
    }
    st += el;
    if (!last){
        st += ";";
    }
    return st;
};

ICO.reqV = function(f){
    if (f.length === 0){
        document.getElementById('ICO-vCard-alert').innerHTML = ICO.vars.reqFields;
    }
};

ICO.buildNameSection = function(){
    var lines = "";
    var fullName = document.getElementById('v-card-N').value;
    ICO.reqV(fullName);
    var N = "N:";
    var parsedName = parser.parseName(fullName);
    N = ICO.appVString(N, parsedName.lastName, false);
    N = ICO.appVString(N, parsedName.firstName, false);
    N = ICO.appVString(N, parsedName.middleName, false);
    N = ICO.appVString(N, parsedName.salutation, false);
    N = ICO.appVString(N, parsedName.suffix, true);
    lines += N+"\n";

    var dispName = document.getElementById('v-card-FN').value;
    ICO.reqV(dispName);
    lines += "FN:"+dispName+"\n";
    return lines;
};

ICO.buildEmailSection = function(){
    var email = document.getElementById('v-card-EMAIL').value;
    if (email.length !== 0){
        return "EMAIL:"+email+"\n";
    }
    return "";
};

ICO.buildPhoneSection = function(){
    var lines = "";
    for (let i=1; i < ICO.vTelDivs.length + 1; i++){
        let ph = "TEL";
        let num = document.getElementById('v-card-TEL'+i).value;
        if (num.length ===0){
            break;
        }
        console.log(num);
        let cell = document.getElementById('v-card-TEL'+i+"-cell").checked;
        let home = document.getElementById('v-card-TEL'+i+"-home").checked;
        let work = document.getElementById('v-card-TEL'+i+"-work").checked;

        if (!cell && !home && !work){
            ph += ":"+num+"\n";
        } else {
            ph += ";TYPE=";
            if (cell){ ph += "cell,"; }
            if (home){ ph += "home,"; }
            if (work){ ph += "work,"; }
            ph = ph.slice(0, -1);
            ph += ":"+num+"\n";
        }
        lines += ph;
    }
    return lines;
};

ICO.buildAddressSection = function(){
    var lines = "";
    for (let i=1; i < ICO.vAdrDivs.length + 1; i++){
        let ad = "ADR";
        let adr1 = document.getElementById('v-card-ADR-l1-'+i).value;
        let adr2 = document.getElementById('v-card-ADR-l2-'+i).value;
        if (adr1.length ===0 && adr2.length ===0){
            break;
        }
        let adrC = document.getElementById('v-ADR-city-'+i).value;
        let adrS = document.getElementById('v-ADR-state-'+i).value;
        let adrZ = document.getElementById('v-ADR-zip-'+i).value;
        let adrCountry = document.getElementById('v-card-ADR-country-'+i).value;
        console.log(adrCountry);

        let home = document.getElementById('v-card-ADR'+i+"-home").checked;
        let work = document.getElementById('v-card-ADR'+i+"-work").checked;
        let postal = document.getElementById('v-card-ADR'+i+"-postal").checked;

        function addFields(){
            let af = ":;";
            af = ICO.appVString(af, adr2, false);
            af = ICO.appVString(af, adr1, false);
            af = ICO.appVString(af, adrC, false);
            af = ICO.appVString(af, adrS, false);
            af = ICO.appVString(af, adrZ, false);
            af = ICO.appVString(af, adrCountry, true);
            ad += af + "\n";
        }

        if (!home && !work && !postal){
            addFields();
        } else {
            ad += ";TYPE=";
            if (home){ ad += "home,"; }
            if (work){ ad += "work,"; }
            if (postal){ ad += "postal,"; }
            ad = ad.slice(0, -1);
            addFields();
        }
        lines += ad;
    }
    return lines;
};

ICO.buildOrgSection = function(){
    var lines = "";
    var org = document.getElementById('v-card-ORG').value;
    if (org.length !== 0){ lines += "ORG:"+org+"\n"; }
    var site = document.getElementById('v-card-URL').value;
    if (site.length !== 0){ lines += "URL:"+site+"\n"; }
    var title = document.getElementById('v-card-TITLE').value;
    if (title.length !== 0){ lines += "TITLE:"+title+"\n"; }
    var role = document.getElementById('v-card-ROLE').value;
    if (role.length !== 0){ lines += "ROLE:"+role+"\n"; }
    return lines;
};

ICO.buildNotesSection = function(){
    var note = document.getElementById('vCard-NOTE').value.replace(/(\r\n|\n|\r)/gm, " ");
    if (note.length !== 0){
        return "NOTE:"+note+"\n";
    }
    return "";
};

ICO.makeVCard = function(){
    var vCard = "BEGIN:VCARD\nVERSION:3.0\n" +
                ICO.buildNameSection() +
                ICO.buildEmailSection() +
                ICO.buildPhoneSection() +
                ICO.buildAddressSection() +
                ICO.buildOrgSection() +
                ICO.buildNotesSection() +
                "END:VCARD";

    document.getElementById("ICO-QR-Text").value = vCard;
    ICO.restQR();

    if(ICO.settings.qrcard.NFC){
        if(ICO.byteCount(vCard) > ICO.vars.maxBytes){
            alert(ICO.vars.NFCBytes);
        }
        ICO.bytesCounter.innerHTML = ICO.byteCount(vCard) + '/'+ICO.vars.maxBytes +' bytes (NFC)';
    }
};
ICO.restQR = function(){
    ICO.makeCode("ICO-QR-Text");
};
}
